import React from 'react'

interface EmptyPageProps{message:string}

export const EmptyPage:React.FC<EmptyPageProps> = ({message}) => {
  return (
    <section className='empty-page page'>{message}</section>
  )
}
